import PropTypes from 'prop-types';

export const propTypes = {
  /**
   * CSS classes
   */
  className: PropTypes.string,

  /**
   * Error Message
   */
  message: PropTypes.string,
};

export const defaultProps = {};
